import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import type { VistaPublica } from '../../../compartido/api';
import { fechaLarga, soles, tramos } from '../../../compartido/formato';
import { Check, Reloj } from '../componentes/Iconos';
import { AvisoError, Cargando } from '../componentes/Piezas';
import { api, mensajeDeError } from '../lib/api';
import { archivoCalendario } from '../lib/fechas';
import { correoDeReserva, olvidarRetencion } from '../lib/sesion';

/** Paso final. El enlace a la sesión llega por correo: es la llave, no hay cuenta. */
export function Confirmada() {
  const { id = '' } = useParams();
  const navegar = useNavigate();
  const [reserva, setReserva] = useState<VistaPublica>();
  const [error, setError] = useState<string>();
  const correo = correoDeReserva(id);

  useEffect(() => {
    api.reserva(id).then(
      (r) => {
        if (r.estado !== 'CONFIRMADA') return navegar(`/pago/${id}`, { replace: true });
        olvidarRetencion();
        setReserva(r);
      },
      (e) => setError(mensajeDeError(e)),
    );
  }, [id, navegar]);

  if (error) {
    return (
      <div className="pantalla">
        <div className="contenido">
          <AvisoError>{error}</AvisoError>
        </div>
      </div>
    );
  }
  if (!reserva) return <Cargando />;

  const descargar = () => {
    const ics = archivoCalendario(reserva, window.location.origin);
    const url = URL.createObjectURL(new Blob([ics], { type: 'text/calendar;charset=utf-8' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = `mentoria-${reserva.fecha}.ics`;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };

  const n = reserva.horas.length;
  return (
    <div className="pantalla" style={{ background: 'var(--oscuro)' }}>
      <div className="celebracion">
        <div className="celebracion__sello">
          <Check />
        </div>
        <h1 className="titulo" style={{ color: '#F7F2EA' }}>
          Quedó reservado
        </h1>
        <p className="parrafo">
          {correo ? (
            <>
              Te enviamos a <span className="fuerte">{correo}</span> el acceso a tu sesión.
            </>
          ) : (
            'Te enviamos por correo el acceso a tu sesión.'
          )}
        </p>
      </div>

      <div className="hoja">
        <div className="contenido">
          <div className="tarjeta">
            <div>
              <div className="antetitulo">Tu sesión</div>
              <div className="monto" style={{ fontSize: 22, marginTop: 5 }}>
                {fechaLarga(reserva.fecha).replace(/^./, (c) => c.toUpperCase())}
              </div>
              <div className="parrafo" style={{ marginTop: 3 }}>
                {tramos(reserva.horas)} · {n} {n === 1 ? 'hora' : 'horas'} (hora de Lima)
              </div>
            </div>
            <hr className="separador" />
            <div className="fila">
              <span className="parrafo" style={{ fontSize: 13 }}>
                Pagado · {n} {n === 1 ? 'hora' : 'horas'} × {soles(reserva.precio / n)}
              </span>
              <span className="monto" style={{ fontSize: 20, color: 'var(--acento-texto)' }}>
                {soles(reserva.precio)}
              </span>
            </div>
          </div>

          <Link to={`/acceso${correo ? `?correo=${encodeURIComponent(correo)}` : ''}`} className="boton">
            Ver mi sesión y el enlace de la reunión
          </Link>

          <button type="button" className="boton boton--secundario" onClick={descargar}>
            Agregar a mi calendario
          </button>

          <div className="aviso">
            <Reloj />
            <p style={{ margin: 0 }}>
              Puedes mover esta sesión hasta <span className="fuerte">2 veces</span>, siempre con <span className="fuerte">24 horas</span> de
              anticipación. No hay devoluciones. Te recordamos por correo un día antes.
            </p>
          </div>

          <Link to="/" className="enlace-texto">
            Reservar otro día
          </Link>
        </div>
      </div>
    </div>
  );
}
